import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckbox, MatCheckboxChange } from '@angular/material';

import { Filter, FilterComponentBase } from '../filters/filters';


@Component({
  selector: 'app-number-filter',
  templateUrl: './number-filter.component.html',
  styleUrls: ['./number-filter.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberFilterComponent),
      multi: true
    },
    {
      provide: FilterComponentBase,
      useExisting: forwardRef(() => NumberFilterComponent)
    }
  ]
})
export class NumberFilterComponent extends FilterComponentBase implements OnInit, ControlValueAccessor {
  @Input() filter: Filter;
  @Input() compact: boolean;
  @Input() label: string;
  @Input() fontSet: string;
  @Input() fontIcon: string;
  @Input() svgIcon: string;
  @Input() icon: string;
  @Input() inputLabel: string;
  @Input() value: number;
  @Input() inputSuffix: string;
  @Output() change = new EventEmitter<any>();

  @ViewChild('checkbox') checkbox: MatCheckbox;
  private onChangeCallback = (_: any) => {};

  ngOnInit() {
    this.checkbox.change.subscribe((e: MatCheckboxChange) => {
      this.onChange();
    });
  }

  onChange() {
    const value = this.checkbox.checked ? this.value : null;
    this.onChangeCallback(value);
    this.change.emit(value);
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.checkbox.registerOnTouched(fn);
  }
}
